/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import { FormattedMessage } from 'js/lib/coursera.react-intl';

import { Link, PageNotification, breakpoints } from '@coursera/cds-core';
import type { LinkProps } from '@coursera/cds-core';

import withSingleTracked from 'bundles/common/components/withSingleTracked';
import TrackedDiv from 'bundles/page/components/TrackedDiv';
import { useTranslationsNotificationBanner } from 'bundles/unified-description-page-common/contexts/consumer/TranslationsNotificationBannerContext';

import _t from 'i18n!nls/xdp';

const TrackedLink = withSingleTracked({ type: 'BUTTON' })<LinkProps>(Link);

const styles = {
  notificationBanner: css`
    background: var(--cds-color-neutral-background-primary);
    padding: var(--cds-spacing-150) var(--cds-spacing-200);
    box-shadow: 0 4px 4px 0 rgb(0 0 0 / 25%);
    margin-top: var(--cds-spacing-100);
    position: relative;
    z-index: 1000;
    width: 100%;
    ${breakpoints.down('xs')} {
      margin-top: var(--cds-spacing-50);
    }
  `,
};

const TranslationsNotificationBanner = () => {
  const { subfolderLanguage, hasTranslations, productType, setHideBanner, openDialog, showBanner } =
    useTranslationsNotificationBanner();

  if (!showBanner) {
    return null;
  }

  return (
    <TrackedDiv
      trackingName="xdp_translations_notification_banner"
      withVisibilityTracking
      data-testid="translations-notification-banner"
    >
      <PageNotification
        severity="information"
        title={_t('This #{productType} is not available in #{subfolderLanguage}', {
          productType: productType.toLocaleLowerCase(),
          subfolderLanguage,
        })}
        onDismiss={() => setHideBanner(true)}
        css={styles.notificationBanner}
      >
        <FormattedMessage
          message={_t("We're translating it into more languages. {viewAllLanguagesLink}")}
          viewAllLanguagesLink={
            hasTranslations ? (
              <TrackedLink
                trackingName="xdp_translations_notification_banner_view_all_languages"
                onClick={(e) => {
                  e.preventDefault();
                  openDialog();
                }}
                href="#"
              >
                {_t('View the languages we have available.')}
              </TrackedLink>
            ) : null
          }
        />
      </PageNotification>
    </TrackedDiv>
  );
};

export default TranslationsNotificationBanner;
